import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { MatSelectionList } from '@angular/material/list';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormFieldService } from '../../services/form-field.service';
import { FormListPickerField, ListPickerOption } from './form-list-picker.model';

@Component({
  selector: 'gio-form-list-picker',
  templateUrl: './form-list-picker.component.html',
  styleUrls: ['./form-list-picker.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormListPickerComponent<N = any> extends FormBaseComponent<FormListPickerField<N>> {
  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  selecteds: ListPickerOption<N>[] = [];

  constructor(
    private cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() {
    this.subscribe = this.service.detectChanges$.subscribe(() => {
      this.cd.detectChanges();
    })
  }

  onComponentDestroy() { }

  selected(item: ListPickerOption<N>, component: MatSelectionList) {
    if (item.action) {
      const callCd = item.action();
      if (callCd) {
        this.service.detectChanges$.next();
      }
    }

    if (this.field.listType == 'action') {
      if (this.field.selected) {
        try {
          this.field.selected(item.value, this.service);
        } catch (err) {
          console.error('Error on list option action');
        }
      } else {
        console.error(`Item doesn't have an action`);
      }
    }

    if (this.field.listType == 'selection') {
      const value = {} as any;
      value[this.field.name] = item.value;
      this.group.patchValue(value);
      this.selecteds = [item];
    }

    if (this.field.listType == 'selection') {
      const value = {} as any;
      value[this.field.name] = item.value;
      this.group.patchValue(value);
    }

    if (this.field.listType == 'multiSelection') {
      const selecteds = component.selectedOptions.selected;
      const values = selecteds.map(s => s.value);
      const value = {} as any;
      value[this.field.name] = values;
      this.group.patchValue(value);
    }


  }

}
